import React, { useState, useEffect } from "react";
import { Modal }      from "react-bootstrap";
import Select         from "react-select";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { parseDate }  from "react-day-picker/moment";
import "react-day-picker/lib/style.css";
import moment         from "moment";
import CloseIcon      from "assets/icons/Close-1.svg";
import CalendarIcon   from "assets/icons/calendar-filter.svg";
import "./Wallet.scss";

const TYPE_OPTIONS = [
  { value: "",           label: "All"      },
  { value: "payment_in", label: "Payment"  },
  { value: "withdraw",   label: "Withdraw" },
];

const formatDate = (date) => moment(date).format("YYYY-MM-DD");

const TransactionFilterModal = ({ show, onClose, filters, onApply, onClear }) => {
  const [startDate, setStartDate] = useState(filters.startDate || "");
  const [endDate, setEndDate]     = useState(filters.endDate || "");
  const [type, setType]           = useState(filters.transactionType || "");

  useEffect(() => {
    if (show) {
      setStartDate(filters.startDate || "");
      setEndDate(filters.endDate || "");
      setType(filters.transactionType || "");
    }
  }, [show]); // eslint-disable-line

  const handleClear = () => {
    setStartDate("");
    setEndDate("");
    setType("");
    onClear();
  };

  const handleApply = () => {
    onApply({ startDate, endDate, transactionType: type });
  };

  const selectedType = TYPE_OPTIONS.find((o) => o.value === type) || null;

  return (
    <Modal className="wallet-filter-modal" show={ show } onHide={ onClose } centered>
      <div className="filter-header">
        <h4 className="filter-title">Filters</h4>
        <button type="button" className="filter-close" onClick={ onClose }>
          <img src={ CloseIcon } alt="close" />
        </button>
      </div>

      <div className="filter-body">
        <label className="filter-label">Duration</label>
        <div className="date-inputs">
          <div className="date-field">
            <img src={ CalendarIcon } alt="calendar" className="calendar-icon" />
            <DayPickerInput
              formatDate={ formatDate }
              parseDate={ parseDate }
              format="YYYY-MM-DD"
              value={ startDate }
              placeholder="Select date"
              onDayChange={ (day) => setStartDate(formatDate(day)) }
            />
          </div>

          <span className="date-sep">-</span>

          <div className="date-field">
            <img src={ CalendarIcon } alt="calendar" className="calendar-icon" />
            <DayPickerInput
              formatDate={ formatDate }
              parseDate={ parseDate }
              format="YYYY-MM-DD"
              value={ endDate }
              placeholder="Select date"
              onDayChange={ (day) => setEndDate(formatDate(day)) }
            />
          </div>
        </div>

        <label className="filter-label">Transaction Type</label>
        <Select
          classNamePrefix="type-select"
          className="type-select"
          placeholder="Select"
          options={ TYPE_OPTIONS }
          value={ selectedType }
          onChange={ (option) => setType(option ? option.value : "") }
        />
      </div>

      <div className="filter-footer">
        <button type="button" className="btn clear-btn" onClick={ handleClear }>Clear Filters</button>
        <button type="button" className="btn filter-apply-btn" onClick={ handleApply }>Filter</button>
      </div>
    </Modal>
  );
};

export default TransactionFilterModal;
